import React from "react";
import {ExclamationMarkTriangle} from "../Support/Icon";
import {EVENT_LEAD_MODAL_CLOSED} from "../Support/Events";

const initialState = {
}

export default class DoiTimeoutError extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
    }

    closeModal() {
        document.dispatchEvent(new CustomEvent(EVENT_LEAD_MODAL_CLOSED));
    }

    render() {
        return (
            <div>
                <p className="flex flex-row items-start mb-3">
                    <ExclamationMarkTriangle className="mt-1" />
                    <span className="ml-2">Entschuldigen Sie, das hat nicht funktioniert.</span>
                </p>
                <p className="mb-8">
                    Der Vorgang hat etwas zu lange gedauert.
                    Sie können dieses Fenster nun schließen.
                    Ihr Scan-Ergebnis erhalten Sie per E-Mail, sobald Sie Ihre E-Mail-Adresse bestätigt haben.
                </p>
                <button className="button" onClick={this.closeModal}>Fenster schliessen</button>
            </div>
        )
    }
}
